import {
  currencyString,
  formatDate,
  isDefined,
  isInstallmentOnOrAfterScheduledDate,
  isLocAfterScheduledDate,
  UseMessageT,
} from '@consumer-frontend/nc-utils';

export const useMessageInAdditionToAutopay: UseMessageT = (props) => {
  const {
    isAutopay,
    loanStatus,
    isAutopayPending,
    isMultiple,
    paymentDate,
    productType,
    scheduledAmount,
    scheduledDate,
  } = props;

  if (!isDefined(loanStatus)
    || !isDefined(paymentDate)
    || !isDefined(productType)
    || !isDefined(scheduledAmount)
    || !isDefined(scheduledDate)
  ) { return undefined; }

  const logicHelperProps = {
    paymentDate,
    productType,
    scheduledDate,
  };

  const isValidDate = isInstallmentOnOrAfterScheduledDate(logicHelperProps) || isLocAfterScheduledDate(logicHelperProps);

  // NCFE-10056 (A-2)
  // NCFE-10057 (A-1)
  if (isAutopay
    && ['current', 'past_due'].includes(loanStatus)
    && (isAutopayPending || isValidDate)
  ) {
    return (
      <p>
        This payment will be made{' '}
        <span className="fw-bold">
          in addition to your
          {isAutopayPending ? ' pending ' : ' '}
          AutoPay {isMultiple ? 'payments' : 'payment'}
        </span>{' '}
        {isMultiple ? 'totaling ' : 'of '}
        {currencyString(scheduledAmount)} scheduled for {formatDate(scheduledDate)}.
      </p>
    );
  }

  return undefined;
};
